module.exports = "/assets/data/b03cdb2a8e727cbf6b1d9baed0d7d424-CW5.data.json";